module.exports = __webpack_public_path__ + "img/sticker_b2s_1.dfcedd44.svg";